import styled from 'styled-components';

export const TopBar = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const TopBarInner = styled.div`
  max-width: 56rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.md};
`;

export const Logo = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  text-decoration: none;
`;

export const LogoMark = styled.span`
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 0.8rem;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.accent} 0%,
    ${({ theme }) => theme.colors.accentDark} 100%
  );
  color: ${({ theme }) => theme.colors.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.05rem;
`;

export const LogoWordmark = styled.span`
  font-size: 1.7rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  letter-spacing: -0.03rem;
`;

export const PromoCta = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 1.2rem;
  border-radius: 999rem;
  background-color: rgba(14, 165, 233, 0.1);
  color: ${({ theme }) => theme.colors.accent};
  font-size: 1.2rem;
  font-weight: 700;
  text-decoration: none;
  border: 0.1rem solid rgba(14, 165, 233, 0.32);
`;

export const Container = styled.div`
  max-width: 56rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg};
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.6rem;
  padding: ${({ theme }) => theme.spacing.xl};
`;

export const SectionTitle = styled.div`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.2rem;
`;

export const BookNowButton = styled.button<{ $accent: string }>`
  background-color: ${({ $accent }) => $accent};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 2rem;
  padding: 0.6rem 1.6rem;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
`;

export const SelectedResultsRow = styled.div`
  display: flex;
  gap: 1.2rem;
  overflow-x: auto;
  padding-bottom: 0.4rem;
`;

export const ResultCard = styled.div`
  min-width: 24rem;
  padding: 1.4rem;
  border-radius: 1.2rem;
  background: ${({ theme }) => theme.colors.accentBgSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.accentBorder};
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

export const ResultAchievement = styled.div`
  font-size: 1.4rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const ResultTimeframe = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slate};
  font-weight: 600;
`;

export const ResultAuthor = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-top: 0.4rem;
`;
